import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="schedule-modal"
export default class extends Controller {
  static targets = ["modal"];

  open(event) {
    event.preventDefault();
    const modalId = event.currentTarget.dataset.scheduleModalId;
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }
  }

  close(event) {
    event.preventDefault();
    const modalId = event.currentTarget.dataset.scheduleModalId;
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      const modalId = event.currentTarget.id;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      }
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      const openModal = document.querySelector('[id^="schedule-modal-"]:not(.hidden)');
      if (openModal) {
        openModal.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      }
    }
  }
}
